// extracted by mini-css-extract-plugin
export default {"container":"n2-z"};